import Vue from "vue"
import App from "./App.vue";
import uweb from 'vue-uweb'
import store from "./store/index";
import router from "./router/index";
import VueLazyload from 'vue-lazyload';
import VueClipboard from 'vue-clipboard2';

require("babel-polyfill");
require("./utils/antdv");
require("./utils/filter");

Vue.use(VueClipboard);
Vue.use(VueLazyload, {preLoad: 1});
Vue.use(uweb, {
	debug: false,
	siteId: "1280886316",
});
VueClipboard.config.autoSetContainer = true;

new Vue({
	store,
	router,
	render: h => h(App),
}).$mount("#app");
